import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
import useScrollBlock from '@/lib/useScrollBlock';

export default function Modal({ noPadding, noFooter, children, onClose }) {
  const [isShowing, setShowing] = useState(false);

  const [blockScroll, allowScroll] = useScrollBlock();

  useEffect(() => {
    blockScroll();
    setShowing(true);
    return () => allowScroll();
  }, [blockScroll, allowScroll]);

  return (
    <Portal>
      <Transition show={isShowing}>
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <Transition.Child
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            as="div"
            className="absolute inset-0"
          >
            <div className="bg-gray-900 bg-opacity-75 absolute inset-0 pointer-events-none z-10" />
          </Transition.Child>
          <div className="relative z-50 w-full md:w-3/4 lg:w-2/5">
            <Transition.Child
              enter="transition ease-in-out duration-300 transform"
              enterFrom="opacity-0 scale-90"
              enterTo="opacity-100 scale-100"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="relative z-20 bg-white shadow-xl lg:shadow-2xl md:rounded-md lg:rounded-lg xl:rounded-2xl overflow-hidden text-base w-full">
                <div
                  className={clsx(
                    'md:rounded-t-md lg:rounded-t-lg xl:rounded-t-2xl',
                    noFooter &&
                      'md:rounded-b-md lg:rounded-b-lg xl:rounded-b-2xl',
                    !noPadding && 'px-6 py-5'
                  )}
                >
                  {children}
                </div>
                {!noFooter && (
                  <div className="flex flex-col md:flex-row md:items-center px-4 md:px-10 py-4 md:justify-end space-y-4 md:space-y-0 md:space-x-4 bg-gray-100 w-full rounded-b-lg">
                    <button
                      className="bg-white rounded-full px-6 py-2 leading-5 font-medium focus:outline-none text-gray-700 hover:text-gray-900 ring-1 ring-black shadow ring-opacity-10 focus:ring-4 focus:ring-opacity-5 focus:text-gray-900"
                      onClick={onClose}
                      type="button"
                    >
                      Aceptar
                    </button>
                  </div>
                )}
              </div>
            </Transition.Child>
          </div>
        </div>
      </Transition>
    </Portal>
  );
}

Modal.defaultProps = {
  noPadding: false,
  noFooter: false,
  children: null,
  onClose: () => null,
};

Modal.propTypes = {
  noPadding: PropTypes.bool,
  noFooter: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func,
};
